import { Button } from "primereact/button";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { useCallback } from "react";
import { selectLoadingImages } from "../../store/selectors/inspectionSelectors";
import { PositiveItem } from "../../types/positiveItem";
import { setToEditImages } from "../../store/slices/positiveItemSlice";
import addImages from "../../assets/addImages.svg";
import { ViewImagesButton } from "../Shared/ViewImagesButton";

export const PositiveItemTableImagesBody = (positiveItem: PositiveItem) => {
    const dispatch = useAppDispatch();

    const loadingImages = useAppSelector(selectLoadingImages);

    const onEditImages = useCallback(() => {
        dispatch(setToEditImages(positiveItem));
    }, [positiveItem]);

    if (loadingImages) {
        return <span className="pi pi-spin pi-spinner" />;
    }

    return (
        <div className="flex">
            <ViewImagesButton item={positiveItem} />
            <Button
                rounded
                text
                onClick={onEditImages}
                tooltip="Select images"
                tooltipOptions={{ position: "top" }}
            >
                <img src={addImages} alt="add-images" />
            </Button>
        </div>
    );
};
